import styled from "styled-components";

export const Error = styled('div')<{ capitalize?: boolean }>`
  color: ${({ theme }) => theme.colours.error};
  margin: 0 0 24px;
  text-align: center;
  ${({ capitalize }) => capitalize && `text-transform: capitalize;`}
`;